// extracted by mini-css-extract-plugin
export default {"wrapper":"NavigationProductSearchbar-sWAph__wrapper","search":"NavigationProductSearchbar-I8Ka8__search","searchinput":"NavigationProductSearchbar-Acn2r__searchinput"};